/*
 eslint-disable @typescript-eslint/no-explicit-any
 */

export function getMessage(value: unknown): string | undefined {
  if (typeof value === 'string') return value;

  if (typeof value === 'object' && value !== null) {
    const msg = (value as any).message;
    if (typeof msg === 'string') return msg;

    for (const nested of Object.values(value)) {
      if (
        typeof nested === 'object' &&
        nested !== null &&
        typeof (nested as any).message === 'string'
      ) {
        return (nested as any).message;
      }
    }
  }

  return undefined;
}

export function getOneSdkErrorMessage(error: unknown): string {
  let msg = getMessage(error);

  const errorDetails =
    (error as any)?.payload?.errorObject?.message || getMessage((error as any)?.payload);

  if (typeof errorDetails === 'string') {
    msg = msg ? `${msg}: ${errorDetails}` : errorDetails;
  }

  return msg || 'An error occurred in FrankieOne SDK';
}
